import { useEffect, useMemo } from 'react';

import { useGetHoFLibrary } from 'actions/hall-of-fame';

// Rows carry an exam *key*; the library carries the name a person recognises. Fetched only
// to resolve those names, which is all the queue needs it for.
const useExamLibrary = () => {
  const { data, getAll: getLibrary } = useGetHoFLibrary();

  useEffect(() => {
    getLibrary();
  }, [getLibrary]);

  const library = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  const examNames = useMemo(
    () =>
      library.reduce((acc, e) => {
        if (e && e.examKey) acc[e.examKey] = e.examName;
        return acc;
      }, {}),
    [library],
  );

  // The scoring type the library holds for each exam. It is the only value the sanitise
  // endpoint accepts for `scoreType`, because settling `SCORE_TYPE_DISPUTED` means
  // agreeing with the library — so the drawer has to know it to offer the settlement.
  const examScoreTypes = useMemo(
    () =>
      library.reduce((acc, e) => {
        if (e && e.examKey) acc[e.examKey] = e.scoreType;
        return acc;
      }, {}),
    [library],
  );

  return { examNames, examScoreTypes };
};

export default useExamLibrary;
